<template>
  <div class="quotes-page"
       v-loading="pageLoading"
       element-loading-text="正在加载中,请稍后"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.2)">
    <el-row :gutter="30"
            class="account-page-info">
      <el-col :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
              class="left-box">
        <div class="left-title">{{ $t("quotes.quotesTitle") }}</div>
        <div class="tabs-container">
          <div class="tab-title">
            <div :class="activeTab === 'HK_STOCK' ? 'is-active' : 'tab-item'"
                 @click="tabChange('HK_STOCK')">
              {{ $t("quotes.hkStock") }}
            </div>
            <div :class="activeTab === 'US_STOCK' ? 'is-active' : 'tab-item'"
                 @click="tabChange('US_STOCK')">
              {{ $t("quotes.usStock") }}
            </div>
            <div :class="activeTab === 'FUTURES' ? 'is-active' : 'tab-item'"
                 @click="tabChange('FUTURES')">
              {{ $t("quotes.futures") }}
            </div>
          </div>
        </div>
        <div v-if="quoteData.length">
          <div v-for="(item, index) in quoteData"
               :key="index">
            <div class="quotes-option-wrap">
              <div class="quotes-option"
                   :class="getTypeClass(item.linkedMarkets).className">
                <div class="flex">
                  <div class="left">
                    <div class="name">
                      <span>{{ item.name }}</span><span class="special-info"
                            v-if="getTypeClass(item.linkedMarkets).showInfo">{{ $t("quotes.notProfessionInfo") }}</span>
                    </div>
                    <div class="en-name">{{ item.enName }}</div>
                  </div>
                  <div class="right"
                       :style="
                      `background:url(${
                        getTypeClass(item.linkedMarkets).bgimg
                      })`
                    ">
                    <div class="tag"
                    v-if="
                        item.actionType === 'CANCEL' &&
                          item.status === 'COMPLETED' &&
                          item.endTime
                      "
                         :style="
                        `color:${getTypeClass(item.linkedMarkets).fontColor}`
                      ">
                      {{ $t("quotes.cancelSuccess") }}
                    </div>
                  </div>
                </div>
                <div class="bottom-box flex">
                  <div class="left">
                    <span v-if="item.price !== 0"
                          class="en-name">{{ item.currency }}</span>
                    <span v-if="item.price === 0"
                          class="price-fee price-fsz">
                      <span class="en-name">{{ item.currency }}</span> 98
                      <span class="en-name">/ {{ $t("quotes.timeUnit.MONTH") }}</span>
                    </span>
                    <span v-else
                          class="price-fsz">{{ item.price
                      }}<span class="en-name">
                        /
                        {{
                          $t(`quotes.timeUnit.${item.timeUnit}`) ||
                            $t("quotes.timeUnit.MONTH")
                        }}</span></span>
                    <span v-if="item.price === 0"
                          class="fee-text">{{
                      $t("quotes.feeContent")
                    }}</span>
                    <span class="time"
                          v-if="item.endTime">{{ item.endTime }} {{ $t("quotes.feeText") }}
                      <span class="validity-box"
                            v-if="['SUBMITTED', 'PROCESSING'].includes(item.status)">{{ $t("quotes.validityPeriod") }}</span>
                    </span>
                  </div>
                  <div class="btn-right">
                    <!-- 立即申请 -->
                    <el-button v-if="item.buttonStatus === 'IMMEDIATE_APPLY'"
                               round
                               class="btn"
                               :style="
                        `color:${getTypeClass(item.linkedMarkets).fontColor}`
                      "
                               @click="applyHandle(item)">{{ $t(`quotes.status.IMMEDIATE_APPLY`) }}</el-button>
                    <!-- 审核中 -->
                    <el-button v-if="['SUBMITTED', 'PROCESSING'].includes(item.status)"
                               round
                               class="btn"
                               :style="
                        `color:${getTypeClass(item.linkedMarkets).fontColor}`
                      ">{{ $t(`quotes.status.PROCESSING`) }}</el-button>
                    <!-- 取消订阅 -->
                    <el-button @click="cancelApplyHandle(item.code)"
                               v-if="item.buttonStatus==='CANCEL'"
                               round
                               class="btn-cancel">{{ $t(`quotes.buttonStatus.COMPLETED`) }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else
             class="nodata-box">
          <img src="@/assets/images/no-data.png"
               alt="" />
          <div>{{ $t("common.nodata") }}</div>
        </div>
      </el-col>
      <el-col :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12">
        <bThreeList :params="recordsData"
                    @cencelFun="cencelFun"
                    :src="src"
                    :text="$t('quotes.noQuotes')"
                    :isShowMore="false" />
      </el-col>
    </el-row>
    <!--弹窗-->
    <apply-dialog @confirmCondition="confirmCondition"
                  :dialogVisible.sync="isPopupShow"
                  :conditionDialogTitle="dialogTitle"
                  :applyCondition="conditionData" />
    <ineligible-dialog :dialogVisible.sync="notMoneyShow"
                       :ineligibleDialogTitle="$t('quotes.addressTips.tips')"
                       :ineligibleTipContent="notMoneyInfo"
                       :btns="btns" />
    <!-- 获取申请码弹窗 -->
    <bDialog :dialogVisible.sync="dialogParams.IsCodeShow"
             :refresh="refresh"
             :closeModal="dialogParams.closeModal"
             :params="dialogParams"
             :component="dialogParams.componentDialog"
             :contiune="dialogParams.contiune"
             :showClose="dialogParams.showClose" />
    <el-dialog class="error-dialog" @confirmCondition="continueHandle"
                  :visible.sync="errorShow"
                  :title="$t('logout.tips')"
                  width="30%">
                  <div v-html="errorInfo"></div>
                  <div v-if="errorType==='TIPS'" slot="footer" class="footer-box">
                    <el-button style="width:40%;margin-bottom:20px;" @click="errorShow=false">{{$t('common.cancel')}}</el-button>
                    <el-button style="width:40%;margin-left:0;" type="primary" @click="continueHandle">{{$t('common.ok')}}</el-button>
                  </div>
                  <div v-else slot="footer" class="footer-box">
                    <el-button style="width:40%;margin-left:0;" type="primary" @click="errorShow=false">{{$t('common.ok')}}</el-button>
                  </div>
     </el-dialog>
     <el-dialog class="error-dialog"
                  :visible.sync="spdialogOpen"
                  :title="$t('logout.tips')"
                  width="30%">
                  <div>{{$t('common.spInfo')}}</div>
                  <div slot="footer" class="footer-box">
                    <el-button style="width:40%;margin-left:0;" type="primary" @click="spdialogOpen=false">{{$t('common.ok')}}</el-button>
                  </div>
     </el-dialog>
  </div>
</template>
<script>
import applyDialog from './applyDialog'
import ineligibleDialog from './ineligibleDialog'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import complete from '../../fund-transfer/info-dialog.vue'
import tradeRequest from '@/api/v2/trade.js'
// import { getDesposiRecords } from '@/api/v2/deposit.js'
import { typeMap } from '../map'
import util from '@/util/util'
export default {
  props: ['recordsData'],
  components: { applyDialog, ineligibleDialog },
  data () {
    return {
      pageLoading: false,
      src: require('@/assets/images/noDeposit.png'),
      selectedItem: {},
      quoteData: [],
      moment: moment,
      dialogTitle: '',
      cancelApply: false,
      code: '',
      activeTab: 'HK_STOCK',
      isActive: true,
      typeMap,
      actionType: 'apply',
      typeList: [],
      notMoneyShow: false,
      conditionData: '',
      isPopupShow: false,
      totalBalanceList: [],
      notMoneyInfo: '',
      dialogParams: {
        IsCodeShow: false,
        closeModal: false,
        orderId: '',
        showClose: false, // 申请码关闭小图标
        contiune: true, // 申请码继续按钮
        componentDialog: complete // 申请码弹窗内容
      },
      btns: [
        {
          text: this.$t('quotes.cancel'),
          handle: 'cancel'
        },
        {
          text: this.$t('quotes.toDeposit'),
          handle: 'toDeposit'
        }
      ],
      errorShow: false,
      errorInfo: '',
      isError: false,
      diffPrice: '',
      errorType: '',
      itemVal: {},
      spdialogOpen: false
    }
  },
  computed: {
    ...mapGetters(['getAccountInfo', 'getClientProfile']),
    ...mapState([
      'userInfo',
      'filterSPTradingAccountList'
    ])
  },
  async mounted () {
    try {
      this.pageLoading = true
      const query = util.getHttpQuery()
      if (query.type) {
        this.activeTab = query.type || 'HK_STOCK'
      }
      console.log(query, 'query')
      await this.getQuoteList()
      this.getTotalBalance()
      this.pageLoading = false
    } catch (err) {
      this.pageLoading = false
    }
  },
  methods: {
    tabChange (val) {
      this.activeTab = val
      this.quoteData = []
      this.getQuoteList()
    },
    getTypeClass (val) {
      if (!val.length) {
        return {
          className: this.typeMap['MIXIN'].className,
          bgimg: this.typeMap['MIXIN'].bgimg,
          fontColor: this.typeMap['MIXIN'].fontColor,
          showInfo: false
        }
      }
      if (val.length && val.length === 1) {
        return {
          className: this.typeMap[val[0]].className,
          bgimg: this.typeMap[val[0]].bgimg,
          fontColor: this.typeMap[val[0]].fontColor,
          showInfo: false
        }
        // 芝交所和新加坡的都用一个背景色
      } else if (
        val.toString() ===
        ['CHICAGO_FUTURES', 'SINGAPORE_FUTURES'].toString() ||
        val.toString() === ['SINGAPORE_FUTURES', 'CHICAGO_FUTURES'].toString()
      ) {
        return {
          className: this.typeMap['CHICAGO_FUTURES'].className,
          bgimg: this.typeMap['CHICAGO_FUTURES'].bgimg,
          fontColor: this.typeMap['CHICAGO_FUTURES'].fontColor,
          showInfo: true
        }
      } else {
        return {
          className: this.typeMap['MIXIN'].className,
          bgimg: this.typeMap['MIXIN'].bgimg,
          fontColor: this.typeMap['MIXIN'].fontColor,
          showInfo: false
        }
      }
    },
    async getQuoteList () {
      let params = {
        queryQuoteServiceHomeType: this.activeTab
      }
      const result = await tradeRequest.getQuoteService(params)
      let data = result.data ? result.data : []
      this.quoteData = data
    },
    // 点击立即申请
    async applyHandle (val) {
      this.selectedItem = val
      this.actionType = 'apply'
      this.typeList = val.linkedMarkets
      this.code = val.code
      this.dialogTitle = this.$t('quotes.conditionTitle')
      this.itemVal = val
       // 有且只有sharp point交易账户 股票期货都拦截 或者只要有sp申请期货都拦截
      if (
        this.userInfo.isSPAccount === 'Y' &&
        (!this.filterSPTradingAccountList.length ||
          val.accountTypeList.includes('FUTURES'))
      ) {
        return (this.spdialogOpen = true)
      }
      // 如果没有正常的交易账户需提示
      if (this.getAccountInfo.length === 0) {
        this.notMoneyInfo = this.$t('quotes.noAccountInfo')
        this.notMoneyShow = true
        this.btns[1] = {
          text: this.$t('quotes.goto'),
          handle: 'toAccountrading'
        }
        return
      }
      this.verifyQuote()
    },
    // 判断余额是否足够
    async checkTotalBalance (val) {
      // 港美股费用
      let stockAmountIsEnough = this.totalBalanceList.some(item => {
        return item.amount >= val.price && item.type === 'STOCK'
      })
      // 期货费用
      let futureAmountIsEnough = this.totalBalanceList.some(item => {
        return item.amount >= val.price && item.type === 'FUTURES'
      })
      if (val.accountTypeList) {
        // 单个市场
        if (val.accountTypeList.length === 1) {
          if (val.accountTypeList[0] === 'STOCK' && !stockAmountIsEnough) {
            this.notMoneyInfo = this.$t(`quotes.stockNotMoneyInfo`)
            this.notMoneyShow = true
          } else if (
            val.accountTypeList[0] === 'FUTURES' &&
            !futureAmountIsEnough
          ) {
            this.notMoneyInfo = this.$t(`quotes.futuresNotMoneyInfo`)
            this.notMoneyShow = true
          } else {
            this.notMoneyShow = false
          }
          // 混合市场
        } else {
          if (!stockAmountIsEnough && !futureAmountIsEnough) {
            this.notMoneyInfo = this.$t(`quotes.mixNotMoneyInfo`)
            this.notMoneyShow = true
          } else {
            this.notMoneyShow = false
          }
        }
      }
    },
    // 获取交易账户余额
    async getTotalBalance () {
      let stockList =
        this.getAccountInfo.filter(item => item.type === 'STOCK') || []
      let futureList =
        this.getAccountInfo.filter(item => item.type === 'FUTURES') || []
      // 证券或期货账户存在
      if (stockList.length > 0 || futureList.length > 0) {
        let commandList = this.getAccountInfo.map(item => {
          return {
            tradeAccountNumber: item.tradeAccountNumber,
            tradeAccountType: item.tradeAccountType
          }
        })
        let res = await tradeRequest.getTotalBalance(commandList)
        if (res.code === 200) {
          this.totalBalanceList = res.data || []
        }
      }
    },
    cencelFun (val) {
      console.log('----->', val)
    },
    confirmCondition () {
      if (this.actionType === 'apply') {
        if (this.typeList.length) {
          // 美股的需要确认资料是否变更
          this.$router.push({
            path: '/QuotesApplyForm',
            query: {
              selectedItem: this.selectedItem,
              typeList: this.typeList,
              code: this.code,
              includesUs: this.typeList.includes('US_STOCK') ? 'yes' : 'no'
            }
          })
        }
      } else {
        this.submitCancelHandle()
      }
    },
    cancelApplyHandle (val) {
      this.actionType = 'cancel'
      this.code = val
      this.conditionData = this.$t(`quotes.cancelApplyData`)
      this.dialogTitle = this.$t('quotes.cancelApplyTitle')
      this.isPopupShow = true
    },
    // 提交取消订阅
    async submitCancelHandle () {
      let params = {
        code: this.code,
        submitSource: 'CP_WEB',
        subscribeNumber: 1
      }
      let res = await tradeRequest.cancelQuoteService(params)
      if (res.code === 200) {
        let { orderId } = res.data
        this.dialogParams.orderId = orderId
        this.submitbtnLoading = false
        this.dialogParams.IsCodeShow = true
      }
    },
    refresh () {
      this.getQuoteList()
    },
    formatMoney(val) {
      return this.$t('quotes.moneyText').replace(/{money}/g, val)
    },
    // 实时行情服务-提交前校验
    async verifyQuote() {
      let params = {
        code: this.code,
        subscribeNumber: 1
      }
      let res = await tradeRequest.verifyQuote(params)
      if (res && res.code === 200) {
        let { errorInfo, errorType, diffPrice } = res.data
        this.errorInfo = errorInfo
        this.diffPrice = diffPrice
        this.errorType = errorType
        // 没有错误的情况
        if (!errorType) {
          let val = {
            ...this.itemVal,
            price: this.diffPrice
          }
          await this.checkTotalBalance(val)
          if (this.notMoneyShow) {
            return
          } else {
            this.quoteContine(this.itemVal)
            return
          }
        }
        this.errorShow = true
        this.isError = true
      }
    },
    async continueHandle() {
      this.errorShow = false
      // 价格为0时不校验余额
      if (this.diffPrice === 0) {
        this.notMoneyShow = false
        this.quoteContine(this.itemVal)
      } else {
        let val = {
          ...this.itemVal,
          price: this.diffPrice
        }
        await this.checkTotalBalance(val)
        if (this.notMoneyShow) {

        } else {
          this.quoteContine(this.itemVal)
        }
      }
    },
    // 行情弹窗
    quoteContine(val) {
      let isEddid = val.linkedMarkets.some(item => {
          return ['EDDID_PRO_BASIS', 'EDDID_PRO_ADVANCED'].includes(item)
        })
      if (isEddid) {
        this.conditionData = this.$t('quotes.eddidProConditiontext', { name: val.name, price: val.price, currency: val.currency ? val.currency : 'HKD' })
      } else {
        this.conditionData =
        `${this.$t('quotes.conditionDataFirsttext')}` +
        `${val.name}${this.formatMoney(val.price)}${this.$t(
          'quotes.conditionDatalasttext'
        )} ${val.price}。`
      }

      this.isPopupShow = true
    }
  }
}
</script>
<style lang="scss">
.quotes-page {
  .el-loading-mask {
    .el-loading-spinner {
      .el-icon-loading,
      .el-loading-text {
        font-size: 20px;
        color: #0c2045;
        font-family: PingFangSC-Semibold, PingFang SC;
      }
    }
  }
  .left-box {
    background-color: #fff;
    min-height: 603px;
    padding: 20px 30px 30px !important;
    border-radius: 5px;
    box-shadow: 0px 3px 7px 0px rgba(179, 179, 179, 0.5) !important;
    position: relative;
    .left-title {
      font-size: 18px;
      line-height: 30px;
      font-weight: 600;
      color: #182a54;
      padding-bottom: 14px;
      border-bottom: 4px solid #e2e2e2;
      box-sizing: border-box;
      // &::after {
      //   content: "";
      //   width: 100%;
      //   height: 1px;
      //   background: #d8d8d8;
      //   position: absolute;
      //   top: 65px;
      //   left: 0;
      // }
    }
    .tabs-container {
      padding-top: 18px;
      .tab-title {
        display: flex;
        justify-content: space-around;
        border-bottom: 1px solid #eee;
        margin-bottom: 20px;
        div {
          color: #717171;
          font-size: 16px;
          height: 36px;
          font-weight: 400;
          line-height: 16px;
        }
        .tab-item {
          cursor: pointer;
        }
        .is-active {
          position: relative;
          color: #fece05;
          cursor: pointer;
          font-weight: 500;
          &::after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-15px);
            width: 30px;
            height: 3px;
            background: #fec000;
            border-radius: 2px;
            z-index: 1;
          }
        }
      }
    }
  }
  .account-page-info {
    margin-left: 0 !important;
    .quotes-option {
      height: 130px !important;
      background-color: white;
      box-shadow: 0 3px 7px 0 rgba(179, 179, 179, 0.5);
      border-radius: 4px;
      background: linear-gradient(270deg, #3871ff, #295fe7);
      margin-bottom: 20px;
      padding: 20px;
      box-sizing: border-box;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .left {
      color: #fff;
      .name {
        font-size: 16px;
        margin-bottom: 5px;
        .special-info {
          font-size: 14px;
        }
      }
      .en-name {
        font-size: 12px;
        opacity: 0.8;
        font-family: PingFangSC, PingFangSC-Regular;
      }
      .price-fsz {
        font-size: 24px;
        padding-left: 4px;
        font-family: DINPro, DINPro-Medium;
      }
      .fee-text {
        font-size: 15px;
        font-weight: 500;
      }
      .price-fee {
        opacity: 0.67;
        margin-right: 10px;
        position: relative;
        &::after {
          content: '';
          display: inline-block;
          width: 90px;
          height: 1px;
          background-color: #fff;
          position: absolute;
          left: 3px;
          bottom: 11px;
        }
      }
      .time {
        font-size: 14px;
        margin-left: 20px;
      }
    }
    .right {
      position: absolute;
      right: 0;
      top: 0;
      width: 130px;
      height: 76px;
      margin: 0 auto;
      background-size: contain !important;
      .tag {
        position: absolute;
        right: 0;
        min-width: 60px;
        height: 24px;
        opacity: 0.7;
        background: #ffffff;
        border-radius: 0px 2px 0px 5px;
        padding: 0 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
      }
    }
    .blue-bg {
      background: linear-gradient(270deg, #3871ff, #295fe7);
    }
    .global-bg {
      background: linear-gradient(270deg, #2dc8eb, #389aec);
    }
    .mixin-bg {
      background: linear-gradient(90deg, #1fbf86, #36e0b0);
      opacity: 1;
    }
    .globalfutures-bg {
      background: linear-gradient(90deg, #1aabb0, #51c7b7 97%);
    }
    .bottom-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .en-name {
        opacity: 1;
      }
      .validity-box {
        padding-left: 6px;
      }
      .btn-right {
        .el-button {
          border: none;
          font-size: 12px;
        }
        .el-button.is-round {
          border-radius: 15px;
          padding: 9px 15px;
          opacity: 0.8;
          background: #ffffff;
        }
        .btn-cancel {
          opacity: 0.8;
          border: 1px solid #ffffff;
          background: none !important;
          color: #fff;
          border-radius: 16px;
        }
      }
    }
  }
  .nodata-box {
    text-align: center;
  }
  .error-dialog{
    .footer-box{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .el-dialog__header{
      text-align: center;
      font-weight: 600;
    }
  }

  @media (max-width: 768px) {
    .layout-container .container .view {
      max-width: 100%;
      padding: 0;
      margin: 0;
    }
    .m-0 {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
    .m15 {
      margin-left: -15px;
      margin-right: -15px;
    }
  }
}
</style>
